/* hc-sticky.js - script de snippets/sticky-add-to-cart.liquid, externalise le 19-08-2026 (defer). */
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    initStickyAddToCart();
  }, 500);

  function initStickyAddToCart() {
    const stickyElement = document.getElementById('stickyAddToCart');

    const addToCartSelectors = [
      'button[name="add"]',
      'button.add-to-cart',
      'button.add-to-cart-button',
      'button.product-form__cart-submit',
      'button.product-form__submit',
      'form[action*="/cart/add"] button[type="submit"]',
      '.ProductForm__AddToCart'
    ];

    let addToCartButton = null;

    for (const selector of addToCartSelectors) {
      const button = document.querySelector(selector);
      if (button) {
        addToCartButton = button;
        break;
      }
    }

    if (!addToCartButton) {
      const observer = new MutationObserver(function(mutations) {
        for (const selector of addToCartSelectors) {
          const button = document.querySelector(selector);
          if (button) {
            addToCartButton = button;
            observer.disconnect();
            setupScrollHandler();
            break;
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(function() {
        observer.disconnect();
      }, 10000);
    } else {
      setupScrollHandler();
    }

    function setupScrollHandler() {
      // Marge de securite (px) : evite le clignotement pile au bord de l'ecran
      const edgeBuffer = 20;

      let isVisible = false;
      let debounceTimer = null;

      function handleScroll() {
        if (!addToCartButton) return;

        const addToCartRect = addToCartButton.getBoundingClientRect();
        // Le bouton principal est "a l'ecran" si une partie est visible dans le viewport,
        // qu'il soit encore plus bas (pas encore atteint) ou deja remonte au-dessus.
        const isOnScreen =
          addToCartRect.bottom > edgeBuffer &&
          addToCartRect.top < (window.innerHeight - edgeBuffer);
        const shouldBeVisible = !isOnScreen;

        if (shouldBeVisible !== isVisible) {
          clearTimeout(debounceTimer);

          debounceTimer = setTimeout(() => {
            if (shouldBeVisible) {
              showStickyButton();
            } else {
              hideStickyButton();
            }
          }, 50);
        }
      }

      function showStickyButton() {
        if (isVisible) return;

        stickyElement.style.display = 'block';

        void stickyElement.offsetWidth;

        stickyElement.classList.add('show');
        isVisible = true;
      }

      function hideStickyButton() {
        if (!isVisible) return;

        stickyElement.classList.remove('show');

        setTimeout(() => {
          if (!stickyElement.classList.contains('show')) {
            stickyElement.style.display = 'none';
          }
          isVisible = false;
        }, 400);
      }

      window.addEventListener('scroll', handleScroll, { passive: true });

      window.addEventListener('resize', handleScroll, { passive: true });

      setTimeout(handleScroll, 300);

      setInterval(handleScroll, 2000);
    }
  }
});

// Function to scroll to top when button is clicked
function scrollToTop(event) {
  event.preventDefault();

  // Show animation by adding then removing the added class
  const button = event.currentTarget;
  button.classList.add('added');

  // Smooth scroll to top
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });

  // Remove added class after a delay to show animation
  setTimeout(() => {
    button.classList.remove('added');
  }, 2000);
}